/* FeaturedSection.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["displayCarousel"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _43 = "._1ygbi70q:focus-visible{outline:var(--_wdxe65)}";
const _42 = "._80omtlke{cursor:pointer}";
const _41 = "._4t3ixy5q{height:var(--ds-space-400,2pc)}";
const _40 = "._1bsbxy5q{width:var(--ds-space-400,2pc)}";
const _39 = "._19it1eso{border:var(--_1m4nn1n)}";
const _38 = "._2rko1ssb{border-radius:50%}";
const _37 = "._11q71bhr{background:var(--ds-surface-overlay,#fff)}";
const _36 = "._zulpud5o{gap:.625rem}";
const _35 = "._1yt4u2gc{padding:var(--ds-space-100,8px)}";
const _34 = "._k48p1nn1{font-weight:400}";
const _33 = "._19pku2gc{margin-top:var(--ds-space-100,8px)}";
const _32 = "._k48p1fw0{font-weight:700}";
const _31 = "._y3gn1h6o{text-align:center}";
const _30 = "._otyrxy5q{margin-bottom:var(--ds-space-400,2pc)}";
const _29 = "._1bah1h6o{justify-content:center}";
const _28 = "._2lx21bp4{flex-direction:column}";
const _27 = "@media (min-width:64rem){._1rqt16hb{grid-template-columns:repeat(3,1fr)}}";
const _26 = "@media (min-width:64rem){._1rqtglyw{grid-template-columns:none}}";
const _25 = "@media (min-width:64rem){._dm2511p5{display:grid}}";
const _24 = "@media (min-width:64rem){._dm251txw{display:flex}}";
const _23 = "@media (min-width:64rem){._1hvkidpf{margin-right:0}}";
const _22 = "@media (min-width:64rem){._1hvku2gc{margin-right:var(--ds-space-100,8px)}}";
const _21 = "@media (min-width:64rem){._1rmjidpf{padding-right:0}}";
const _20 = "@media (min-width:64rem){._1rmj1ejb{padding-right:var(--ds-space-300,24px)}}";
const _19 = "@media (min-width:64rem){}";
const _18 = "@media (min-width:64rem){._pdlmxy5q{gap:var(--ds-space-400,2pc)}._zp81ewfl{overflow-x:visible}._1mbpewfl{overflow-y:visible}._tv31f1gs{transition:transform .3s ease-in-out}}";
const _17 = "@media (min-width:48rem) and (max-width:63.99rem){._1gzv1ejb{gap:var(--ds-space-300,24px)}._1lh7xy5q{padding-right:var(--ds-space-400,2pc)}._d97midpf{margin-right:0}}";
const _16 = "._qtt8glyw{list-style:none}";
const _15 = "._18s81dm2{margin:var(--ds-space-negative-400,-2pc) 0 var(--ds-space-negative-400,-2pc) var(--ds-space-negative-300,-24px)}";
const _14 = "._1yt4sgn3{padding:var(--ds-space-050,4px) var(--ds-space-300,24px) var(--ds-space-400,2pc) var(--ds-space-300,24px)}";
const _13 = "._18m91wug{overflow-y:auto}";
const _12 = "._1reo1wug{overflow-x:auto}";
const _11 = "._zulppxbi{gap:var(--ds-space-200,1pc)}";
const _10 = "@media (min-width:48rem) and (max-width:63.99rem){._1b7e1ejb{margin-bottom:var(--ds-space-300,24px)}}";
const _9 = "@media (min-width:48rem){._1svyxy5q{margin-bottom:var(--ds-space-400,2pc)}}";
const _8 = "._kqswh2mm{position:relative}";
const _7 = "._otyrpxbi{margin-bottom:var(--ds-space-200,1pc)}";
const _6 = "._4cvr1h6o{align-items:center}";
const _5 = "._1bah1yb4{justify-content:space-between}";
const _4 = "._1e0c1txw{display:flex}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { IconButton } from '@atlaskit/button/new';
import ArrowLeft from '@atlaskit/icon/glyph/chevron-left-large';
import ArrowRight from '@atlaskit/icon/glyph/chevron-right-large';
import ChevronLeftIcon from '@atlaskit/icon/utility/chevron-left';
import ChevronRightIcon from '@atlaskit/icon/utility/chevron-right';
import { media } from '@atlaskit/primitives/responsive';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { BodyLarge, H3, useMpacConfiguration } from '@atlassian/mpac-primitives';
import { MPAC_CONFIGURATION_KEYS } from '@atlassian/mpac-types';
import shuffle from 'lodash/shuffle';
import { useMemo } from 'react';
import { ArrowsContainer, CarouselContainer, Dot, FocusButton, FocusButtonText, PaginationDots, useCarouselNavigation } from './Carousel';
import { collections } from './constants';
import { FeaturedCard } from './FeaturedCard';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _3 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const _2 = "._19pk1b66{margin-top:var(--ds-space-050,4px)}";
const Description = forwardRef((_ref, __cmplr) => {
  let {
      as: C = BodyLarge,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pk1b66 _syaz1gjq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Description.displayName = 'Description';
}
const FeaturedSectionStyle = null;
const SectionHeader = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_4, _5, _6, _7, _8, _9, _10]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _1bah1yb4 _4cvr1h6o _otyrpxbi _kqswh2mm _1svyxy5q _1b7e1ejb", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SectionHeader.displayName = 'SectionHeader';
}
const ArrowButtonStyle = null;
const CardsWrapper = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  const {
      displayCarousel
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_11, _12, _13, _14, _15, _16, _4, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulppxbi _1reo1wug _18m91wug _1yt4sgn3 _18s81dm2 _qtt8glyw _1e0c1txw _1gzv1ejb _1lh7xy5q _d97midpf _pdlmxy5q _zp81ewfl _1mbpewfl _tv31f1gs", __cmplp.displayCarousel ? "_1rmj1ejb" : "_1rmjidpf", __cmplp.displayCarousel ? "_1hvku2gc" : "_1hvkidpf", __cmplp.displayCarousel ? "_dm251txw" : "_dm2511p5", __cmplp.displayCarousel ? "_1rqtglyw" : "_1rqt16hb", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  CardsWrapper.displayName = 'CardsWrapper';
}
const SectionHeaderStyle = null;
const H3Style = null;
const DescriptionStyle = null;

// eslint-disable-next-line max-lines-per-function
export const FeaturedSection = _ref4 => {
  let {
    shouldCollectionShuffle = true
  } = _ref4;
  const {
    checkEnableGateById,
    enableMpacWebCoherence
  } = useStatsig();
  const {
    getSectionConfiguration
  } = useMpacConfiguration();
  const featuredSectionConfig = getSectionConfiguration(MPAC_CONFIGURATION_KEYS.featuredSection);
  const collectionsToShow = useMemo(() => {
    const {
      tiles: configuredTiles,
      isShuffleEnabled
    } = featuredSectionConfig !== null && featuredSectionConfig !== void 0 ? featuredSectionConfig : {};
    const tilesToUse = configuredTiles || collections;
    const filteredTiles = tilesToUse.filter(tile => {
      if (!tile) {
        return false;
      }
      if (!tile.featureGate) {
        return true;
      }
      return checkEnableGateById(tile.featureGate);
    });
    return shouldCollectionShuffle && isShuffleEnabled ? shuffle(filteredTiles) : filteredTiles;
  }, [featuredSectionConfig, shouldCollectionShuffle, checkEnableGateById]);
  const displayCarousel = collectionsToShow.length > 3;
  const {
    currentIndex,
    itemsPerSection,
    setCurrentIndex,
    totalSections,
    isLastSection,
    handlePrev,
    handleNext,
    handleRightArrowKeyDown,
    goToLeftArrowControl,
    handleFocusButtonPress,
    leftArrowRef,
    focusButtonRef,
    cardRefs
  } = useCarouselNavigation();
  const startCard = isLastSection ? collectionsToShow.length - itemsPerSection : currentIndex * itemsPerSection;
  const endCard = startCard + itemsPerSection;
  const cardWidthPercentage = 28;
  const partialCardWidthPercentage = 17;
  const cardWrapperGapsWidth = 16;
  const getTabIndex = index => {
    if (window.innerWidth < 1024) {
      return 0;
    }
    return index >= startCard && index < endCard ? 0 : -1;
  };
  if (enableMpacWebCoherence()) {
    var _featuredSectionConfi, _featuredSectionConfi2;
    return /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_4, _28]
      }), /*#__PURE__*/_jsxs("div", {
        className: ax(["_1e0c1txw _2lx21bp4"]),
        children: [/*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_4, _29, _6, _30, _8, _31, _10]
          }), /*#__PURE__*/_jsxs("div", {
            className: ax(["_1e0c1txw _1bah1h6o _4cvr1h6o _otyrxy5q _kqswh2mm _y3gn1h6o _1b7e1ejb"]),
            children: [/*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_32, _31]
                }), /*#__PURE__*/_jsx(H3, {
                  as: "h2",
                  className: ax(["_k48p1fw0 _y3gn1h6o"]),
                  children: (_featuredSectionConfi = featuredSectionConfig === null || featuredSectionConfig === void 0 ? void 0 : featuredSectionConfig.heading) !== null && _featuredSectionConfi !== void 0 ? _featuredSectionConfi : 'Featured'
                })]
              }), /*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_33, _34, _31]
                }), /*#__PURE__*/_jsx(BodyLarge, {
                  className: ax(["_19pku2gc _k48p1nn1 _y3gn1h6o"]),
                  children: (_featuredSectionConfi2 = featuredSectionConfig === null || featuredSectionConfig === void 0 ? void 0 : featuredSectionConfig.subHeading) !== null && _featuredSectionConfi2 !== void 0 ? _featuredSectionConfi2 : 'Experience and engage with our curated assortment of apps'
                })]
              })]
            }), displayCarousel && /*#__PURE__*/_jsxs(ArrowsContainer, {
              children: [/*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_35, _36, _37, _38, _39, _40, _41, _42, _43]
                }), /*#__PURE__*/_jsx("button", {
                  ref: leftArrowRef,
                  onClick: handlePrev,
                  className: ax(["_1yt4u2gc _zulpud5o _11q71bhr _2rko1ssb _19it1eso _1bsbxy5q _4t3ixy5q _80omtlke _1ygbi70q"]),
                  style: {
                    "--_1m4nn1n": ix("0.0625rem solid ".concat("var(--ds-border-bold, #758195)")),
                    "--_wdxe65": ix("0.0625rem solid ".concat("var(--ds-border-focused, #388BFF)"))
                  },
                  children: /*#__PURE__*/_jsx(ChevronLeftIcon, {
                    label: "Previous section"
                  })
                })]
              }), /*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_35, _36, _37, _38, _39, _40, _41, _42, _43]
                }), /*#__PURE__*/_jsx("button", {
                  onClick: handleNext,
                  onKeyDown: event => handleRightArrowKeyDown(event),
                  className: ax(["_1yt4u2gc _zulpud5o _11q71bhr _2rko1ssb _19it1eso _1bsbxy5q _4t3ixy5q _80omtlke _1ygbi70q"]),
                  style: {
                    "--_1m4nn1n": ix("0.0625rem solid ".concat("var(--ds-border-bold, #758195)")),
                    "--_wdxe65": ix("0.0625rem solid ".concat("var(--ds-border-focused, #388BFF)"))
                  },
                  children: /*#__PURE__*/_jsx(ChevronRightIcon, {
                    label: "Next section"
                  })
                })]
              })]
            })]
          })]
        }), /*#__PURE__*/_jsx(CarouselContainer, {
          isLastSection: isLastSection,
          displayCarousel: displayCarousel,
          children: /*#__PURE__*/_jsx(CardsWrapper, {
            as: "ul",
            "data-testid": "carousel-cards-wrapper",
            displayCarousel: displayCarousel,
            style: {
              transform: isLastSection ? "translateX(-".concat((collectionsToShow.length - itemsPerSection - 1) * cardWidthPercentage + partialCardWidthPercentage, "%) translateX(").concat((collectionsToShow.length - itemsPerSection - 1) * -cardWrapperGapsWidth, "px)") : "translateX(".concat(currentIndex * itemsPerSection * -cardWidthPercentage, "%) translateX(").concat(currentIndex * itemsPerSection * -cardWrapperGapsWidth, "px)")
            },
            children: collectionsToShow.map((collection, index) => {
              const {
                title,
                description,
                image,
                redirectUrl
              } = collection;
              return /*#__PURE__*/_jsx(FeaturedCard, {
                title: title,
                description: description,
                image: image,
                navigationUrl: redirectUrl,
                ariaHidden: true,
                ref: el => cardRefs.current[index] = el,
                tabIndex: getTabIndex(index),
                ariaLabel: "Item ".concat(index + 1, " of ").concat(collectionsToShow.length, " ").concat(title, " ").concat(description)
              }, index);
            })
          })
        }), /*#__PURE__*/_jsx(FocusButton, {
          displayCarousel: displayCarousel,
          ref: focusButtonRef,
          onClick: goToLeftArrowControl,
          onKeyDown: handleFocusButtonPress,
          "aria-label": "Tap to move through the collections",
          children: /*#__PURE__*/_jsx(FocusButtonText, {
            children: "Tap to navigate"
          })
        }), /*#__PURE__*/_jsx(PaginationDots, {
          displayCarousel: displayCarousel,
          children: Array.from({
            length: totalSections
          }).map((_, index) => /*#__PURE__*/_jsx(Dot, {
            tabIndex: -1,
            active: index === currentIndex,
            onClick: () => setCurrentIndex(index)
          }, index))
        })]
      })]
    });
  }
  return /*#__PURE__*/_jsxs("section", {
    children: [/*#__PURE__*/_jsxs(SectionHeader, {
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(H3, {
          as: "h2",
          children: "Featured"
        }), /*#__PURE__*/_jsx(Description, {
          children: "Experience and engage with our curated assortment of apps"
        })]
      }), displayCarousel && /*#__PURE__*/_jsxs(ArrowsContainer, {
        children: [/*#__PURE__*/_jsx(IconButton, {
          ref: leftArrowRef,
          shape: "circle",
          icon: ArrowLeft,
          label: "Previous section",
          onClick: handlePrev
        }), /*#__PURE__*/_jsx(IconButton, {
          shape: "circle",
          icon: ArrowRight,
          label: "Next section",
          onClick: handleNext,
          onKeyDown: event => handleRightArrowKeyDown(event)
        })]
      })]
    }), /*#__PURE__*/_jsx(CarouselContainer, {
      isLastSection: isLastSection,
      displayCarousel: displayCarousel,
      children: /*#__PURE__*/_jsx(CardsWrapper, {
        as: "ul",
        "data-testid": "carousel-cards-wrapper",
        displayCarousel: displayCarousel,
        style: {
          transform: isLastSection ? "translateX(-".concat((collectionsToShow.length - itemsPerSection - 1) * cardWidthPercentage + partialCardWidthPercentage, "%) translateX(").concat((collectionsToShow.length - itemsPerSection - 1) * -cardWrapperGapsWidth, "px)") : "translateX(".concat(currentIndex * itemsPerSection * -cardWidthPercentage, "%) translateX(").concat(currentIndex * itemsPerSection * -cardWrapperGapsWidth, "px)")
        },
        children: collectionsToShow.map((collection, index) => {
          const {
            title,
            description,
            image,
            redirectUrl
          } = collection;
          return /*#__PURE__*/_jsx(FeaturedCard, {
            title: title,
            description: description,
            image: image,
            navigationUrl: redirectUrl,
            ariaHidden: true,
            ref: el => cardRefs.current[index] = el,
            tabIndex: getTabIndex(index),
            ariaLabel: "Item ".concat(index + 1, " of ").concat(collectionsToShow.length, " ").concat(title, " ").concat(description)
          }, index);
        })
      })
    }), /*#__PURE__*/_jsx(FocusButton, {
      displayCarousel: displayCarousel,
      ref: focusButtonRef,
      onClick: goToLeftArrowControl,
      onKeyDown: handleFocusButtonPress,
      "aria-label": "Tap to move through the collections",
      children: /*#__PURE__*/_jsx(FocusButtonText, {
        children: "Tap to navigate"
      })
    }), /*#__PURE__*/_jsx(PaginationDots, {
      displayCarousel: displayCarousel,
      children: Array.from({
        length: totalSections
      }).map((_, index) => /*#__PURE__*/_jsx(Dot, {
        tabIndex: -1,
        active: index === currentIndex,
        onClick: () => setCurrentIndex(index)
      }, index))
    })]
  });
};